/* SVICLOUDnet — device-support lookup (/pages/device-support).
   Full order number (STVC-####) plus the order's email OR phone — owner decision 2026-10-01. Backend: n8n "SVICLOUDnet — Support Verify
   + WhatsApp Router" (scripts/svicloud_support_01_backend.py). A verified buyer gets a WhatsApp
   button whose prefill carries "Verified purchase …", which the WhatsApp flow routes straight to
   the customer menu. The Turnstile block is the hardened version from svi-track.js (2026-09-28).
   Note: the site-wide WhatsApp gate (snippets/whatsapp-gate.liquid) only rewrites links present
   at page load, so the button rendered here after a successful check is never rewritten — a
   verified customer in a non-selling market can still reach us on WhatsApp. */
(function () {
  'use strict';
  var root = document.querySelector('[data-svi-support]');
  if (!root) return;

  var WEBHOOK = root.getAttribute('data-webhook-url');
  var SITEKEY = root.getAttribute('data-turnstile-sitekey');
  var form = root.querySelector('#svi-support-form');
  var fOrder = root.querySelector('#svi-support-order');
  var fEmail = root.querySelector('#svi-support-email');
  var fPhone = root.querySelector('#svi-support-phone');
  var out = root.querySelector('#svi-support-result');
  var btn = root.querySelector('#svi-support-submit');
  var tsHost = root.querySelector('#svi-support-turnstile');
  var tsWidget = null;
  var EMAIL = 'shop@svicloudnet.com';
  var WA_SVG = '<svg viewBox="0 0 32 32" aria-hidden="true"><path d="M16 0C7.16 0 0 7.16 0 16c0 2.82.74 5.57 2.14 8L0 32l8.19-2.12A15.9 15.9 0 0 0 16 32c8.84 0 16-7.16 16-16S24.84 0 16 0zm0 29.09c-2.51 0-4.96-.68-7.1-1.95l-.51-.3-4.86 1.25 1.3-4.73-.33-.49A13.05 13.05 0 0 1 2.91 16C2.91 8.77 8.77 2.91 16 2.91S29.09 8.77 29.09 16 23.23 29.09 16 29.09zm7.16-9.78c-.39-.2-2.3-1.14-2.66-1.27-.36-.13-.62-.2-.88.2-.26.39-1 1.27-1.23 1.53-.23.26-.45.29-.84.1-.39-.2-1.65-.61-3.14-1.94-1.16-1.04-1.94-2.32-2.17-2.71-.23-.39-.02-.6.17-.8.18-.17.39-.45.58-.68.2-.23.26-.39.39-.65.13-.26.07-.49-.03-.68-.1-.2-.88-2.12-1.2-2.9-.32-.77-.64-.66-.88-.67h-.75c-.26 0-.68.1-1.04.49-.36.39-1.36 1.33-1.36 3.25s1.4 3.77 1.59 4.03c.2.26 2.75 4.2 6.66 5.89.93.4 1.66.64 2.23.82.94.3 1.79.26 2.46.16.75-.11 2.3-.94 2.63-1.85.32-.91.32-1.69.23-1.85-.1-.16-.36-.26-.75-.45z"/></svg>';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function note(kind, zh, en, extra) {
    return '<div class="svi-note ' + (kind ? 'svi-note--' + kind : '') + '">' +
      '<h3>' + zh + '</h3><p class="en">' + en + '</p>' + (extra || '') + '</div>';
  }

  /* ── Turnstile (hardened, from svi-track.js) ─────────────────────────── */
  var tsToken = '', tsErrors = 0, tsCode = '', tsWatch = null;
  var tsNote = document.createElement('div');
  tsNote.className = 'svi-ts-note'; tsNote.setAttribute('role', 'status'); tsNote.hidden = true;
  tsHost.parentNode.insertBefore(tsNote, tsHost.nextSibling);
  function tsStatus(html) { tsNote.innerHTML = html || ''; tsNote.hidden = !html; }
  function tsExplain() {
    var restart = '<button type="button" class="svi-ts-note__btn" data-ts-restart>重新驗證 Restart verification</button>';
    tsStatus(tsErrors
      ? ('驗證未能完成 Verification could not complete' + (tsCode ? ' (code ' + esc(tsCode) + ')' : '') + '. ' + restart +
         '<br><span>如持續失敗，請暫停 VPN 或廣告攔截器，或改用其他瀏覽器。If it keeps failing, pause your VPN or ad-blocker, or try another browser.</span>')
      : ('驗證時間較平常長。Verification is taking longer than usual. ' + restart +
         '<br><span>如持續轉動，請暫停 VPN 或廣告攔截器，或改用其他瀏覽器。If it keeps spinning, pause your VPN or ad-blocker, or try another browser.</span>'));
  }
  function tsArm() { clearTimeout(tsWatch); tsWatch = setTimeout(function () { if (!tsToken) tsExplain(); }, 15000); }
  function tsRestart() {
    tsToken = ''; tsErrors = 0; tsCode = ''; tsStatus('');
    if (window.turnstile && tsWidget !== null) { try { window.turnstile.reset(tsWidget); } catch (e) {} }
    tsArm();
  }
  tsNote.addEventListener('click', function (e) {
    if (e.target && e.target.hasAttribute('data-ts-restart')) tsRestart();
  });
  window.sviSupportTurnstileReady = function () {
    if (!SITEKEY || !window.turnstile || tsWidget !== null) return;
    tsWidget = window.turnstile.render(tsHost, {
      sitekey: SITEKEY, theme: 'light', retry: 'auto', 'retry-interval': 2500,
      'refresh-expired': 'auto', 'refresh-timeout': 'auto',
      callback: function (t) { tsToken = t || ''; tsErrors = 0; tsCode = ''; clearTimeout(tsWatch); tsStatus(''); },
      'expired-callback': function () { tsToken = ''; tsArm(); },
      'timeout-callback': function () { tsToken = ''; tsArm(); },
      'before-interactive-callback': function () { clearTimeout(tsWatch); tsStatus(''); },
      'after-interactive-callback': function () { tsArm(); },
      'error-callback': function (code) {
        tsToken = ''; tsErrors++; tsCode = String(code || '');
        if (tsErrors >= 3) tsExplain();
      }
    });
    tsArm();
  };
  (function loadTurnstile() {
    if (!SITEKEY) return;
    if (window.turnstile) { window.sviSupportTurnstileReady(); return; }
    var s = document.createElement('script');
    s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?onload=sviSupportTurnstileReady&render=explicit';
    s.async = true; s.defer = true;
    document.head.appendChild(s);
  })();

  var ORDER_RE = /^\s*ST[A-Z]{2}[\s\-_]?\d{3,6}\s*$/i;
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  /* ── Results ──────────────────────────────────────────────────────────── */
  var GUIDES =
    '<ul class="svi-links">' +
      '<li><a href="/pages/troubleshooting">問題排解 Troubleshooting</a></li>' +
      '<li><a href="/pages/set-up-guide">設置及安裝 Set-up guide</a></li>' +
      '<li><a href="/pages/getting-started">新手入門 Getting started</a></li>' +
      '<li><a href="/pages/general-faqs">常見問題 General FAQs</a></li>' +
    '</ul>';

  function renderVerified(res) {
    var via = { email: '電郵 email', phone: '電話 phone' }[res.via] || '';
    out.innerHTML = note('ok', '已確認你的購買記錄 ✓', 'Purchase verified ✓',
      '<p>已透過' + esc(via.split(' ')[0]) + '確認：<strong>' + esc(res.label) + '</strong>。請按下方按鈕在 WhatsApp 聯絡我們，訊息已預先填好，客服會優先處理。</p>' +
      '<p class="en">Verified by ' + esc(via.split(' ').slice(1).join(' ')) + ': <strong>' + esc(res.label) +
      '</strong>. Tap below to message us on WhatsApp — the message is pre-filled so our team can help you straight away.</p>' +
      '<div class="svi-cta">' +
        '<a class="svi-cta__wa" href="' + esc(res.wa_url) + '" target="_blank" rel="noopener">' + WA_SVG + 'WhatsApp 聯絡客服 · Chat with us</a>' +
        '<a class="svi-cta__alt" href="/pages/track-order">查詢物流 Track order</a>' +
      '</div>' +
      '<p style="margin-top:.8rem">或電郵 Or email: <strong>' + EMAIL + '</strong></p>');
  }

  function renderNotFound() {
    out.innerHTML = note('warn', '找不到相符的購買記錄', 'We couldn’t find a purchase with these details',
      '<p>很抱歉，我們未能為這部機器進行檢查——它的購買、保固及啟用記錄都由售出該機器的商店保存，我們沒有任何相關資料。建議您聯絡當初購買的商店，他們最能為您提供協助。同時，以下指南可解決大部分常見問題：</p>' +
      '<p class="en">We’re sorry we can’t check this device for you — its purchase, warranty and activation records are held by the store that sold it, and we don’t have any information about it. The seller you bought it from is best placed to help. Meanwhile, these guides solve the most common issues:</p>' +
      GUIDES +
      '<p style="margin-top:.8rem">如您確實在本店購買，請電郵 <strong>' + EMAIL + '</strong>，我們會為您查找。</p>' +
      '<p class="en">If you did buy from us, email <strong>' + EMAIL + '</strong> and we’ll look it up.</p>');
  }

  function render(res) {
    switch (res && res.state) {
      case 'verified': return renderVerified(res);
      case 'not_found': return renderNotFound();
      case 'invalid_input':
        var why = {
          order: ['請輸入完整訂單編號，格式為 STxx-xxxx。', 'Enter the full order number in the format STxx-xxxx.'],
          contact: ['請同時填寫下單時使用的電郵或電話（其中一項）。', 'Also enter the email or phone used on the order (either one).'],
          email: ['電郵地址格式不正確。', 'That email address doesn’t look right.']
        }[res.field] || ['請檢查輸入內容。', 'Please check what you entered.'];
        out.innerHTML = note('warn', '請檢查輸入內容', 'Please check what you entered',
          '<p>' + why[0] + '</p><p class="en">' + why[1] + '</p>');
        return;
      case 'verification_failed':
        out.innerHTML = note('warn', '驗證未能完成', 'Verification didn’t complete', '<p>請重新完成驗證後再試。</p><p class="en">Please complete the verification again and retry.</p>');
        return;
      default:
        out.innerHTML = note('stop', '暫時無法查詢', 'The check is temporarily unavailable',
          '<p>請稍後再試，或電郵 <strong>' + EMAIL + '</strong>。</p><p class="en">Please try again shortly, or email <strong>' + EMAIL + '</strong>.</p>');
    }
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var order = (fOrder.value || '').trim(), email = (fEmail.value || '').trim(), phone = (fPhone.value || '').trim();
    if (!ORDER_RE.test(order)) { render({ state: 'invalid_input', field: 'order' }); return; }
    if (!email && phone.replace(/\D/g, '').length < 8) { render({ state: 'invalid_input', field: 'contact' }); return; }
    if (email && !EMAIL_RE.test(email)) { render({ state: 'invalid_input', field: 'email' }); return; }
    var token = '';
    if (SITEKEY) {
      token = tsToken || (window.turnstile && tsWidget !== null ? (window.turnstile.getResponse(tsWidget) || '') : '');
      if (!token) { out.innerHTML = note('warn', '請先完成驗證', 'Please complete the verification first.', ''); tsExplain(); return; }
    }
    btn.disabled = true;
    out.innerHTML = '<div class="svi-skel"><div style="width:45%"></div><div style="width:80%"></div><div style="width:65%"></div></div>';
    fetch(WEBHOOK, { method: 'POST', headers: { 'Content-Type': 'application/json' },
                     body: JSON.stringify({ order_number: order, email: email, phone: phone, turnstile_token: token }) })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () { render({ state: 'network_error' }); })
      .finally(function () { btn.disabled = false; tsRestart(); });   // Turnstile tokens are single-use
  });
})();
